import _L from "../../../util/Labels";
import { _ModalConfirmacionBasicoV2 } from "../../controlD3/ModalThings/ModalConfirmacionBasicoV2";
import { _ModalForm } from "../../controlD3/ModalThings/ModalForm";
import { DateV2 } from "../../../util/DateV2";
import { Entidad } from "../../../data/Entidad";
import { Fields, FormGenerator, IField } from "../../controlD3/Formulario";
import { ModalThingsUtil } from "../../controlD3/ModalThings/Utils";
import { NotificacionV2 } from "../../controlD3/NotificacionV2";
import { UIUtilTime } from "../../util/Time";
import * as d3 from "d3";
import CloseIcon from '../../../../bin/image/iconos/ic_close2.svg?raw';

import CAccionPermiso = Entidad.CAccionPermiso;
import { DataModuloMain } from "../../../data/ModuloMain";
import { ICicloEscolar, ICicloEscolarPeriodo } from "../../../data/entidad/CicloEscolar";
import { MCicloEscolar } from "../../../data/model/MCicloEscolar";

interface ICicloEscolarPeriodoValidation extends ICicloEscolarPeriodo {
    Valid: boolean;
    ValidationCode: number;
}

export function GetCicloEscolarPeriodoForm(action: (CAccionPermiso.Agregar | CAccionPermiso.Editar), cicloInfo: MCicloEscolar = <MCicloEscolar>{}, idSchool: number, usesMateriasModule = false) {
    const isEdition = action == CAccionPermiso.Editar;

    let datoCicloInfoInFormData: ICicloEscolar = Object.assign(<ICicloEscolar>{
        Periodos: [],
    }, cicloInfo);

    if (isEdition) {
        datoCicloInfoInFormData.Periodos = [...(cicloInfo?.Periodos || [])]
        datoCicloInfoInFormData.FechaInicio = datoCicloInfoInFormData?.FechaInicio ? UIUtilTime._FmtToInputDate(datoCicloInfoInFormData.FechaInicio, idSchool) : null;
        datoCicloInfoInFormData.FechaFin = datoCicloInfoInFormData?.FechaFin ? UIUtilTime._FmtToInputDate(datoCicloInfoInFormData.FechaFin, idSchool) : null;
    }

    let datoCicloInfoInForm = new MCicloEscolar({ ...datoCicloInfoInFormData });

    const periodsProcessing: ICicloEscolarPeriodo[] = datoCicloInfoInForm.Periodos.map<ICicloEscolarPeriodo>(d => ({ ...d }));

    const schema: IField<ICicloEscolar>[] = [
        {
            type: Fields.input,
            inputAttr: { type: "text", maxlength: 120, required: true, disabled: isEdition, removeBorder: isEdition },
            labelText: "d_field_nombre",
            model: "Nombre"
        },
        {
            type: Fields.input,
            inputAttr: { type: "date", required: true, disabled: isEdition, removeBorder: isEdition },
            labelText: "d_field_fechainicio",
            model: "FechaInicio",
            onValidate: () => {
                if (form._Data.FechaFin)
                    form._ValideItem("FechaFin");
                return true;
            }
        },
        {
            type: Fields.input,
            inputAttr: { type: "date", required: true, disabled: isEdition, removeBorder: isEdition },
            labelText: "d_field_fechafin",
            model: "FechaFin",
            onValidate: (dato) => {
                let fechaInicio = new Date(form._Data.FechaInicio);
                let fechaFin = new Date(dato);
                if (!isNaN(Number(fechaInicio)) && !isNaN(Number(fechaFin))) {
                    return (fechaFin > fechaInicio);
                }
                return true;
            },
        },
    ]

    if (usesMateriasModule) {
        schema.push({
            model: "Periodos", type: "unknown", labelText: "d_field_periods",
            unknowAttrs: { required: true },
            onLoad: ({ row }) => {
                UI_CreatePeriodsRow(row, periodsProcessing, idSchool);
            },
            onGetFixedValue: () => {
                return periodsProcessing;
            },
            onValidate: (dato) => {
                if (!dato?.length) return false;
                const validatedPeriods = ValidatePeriods(dato);
                const periodsNoValid = validatedPeriods.filter(d => d.Valid == false);

                if (periodsNoValid.length) {
                    if (periodsNoValid.some(d => d.ValidationCode == -1)) {
                        NotificacionV2._Mostrar(_L("panelcicloescolar.notif_periods_name_rep"), "ADVERTENCIA");
                    } else if (periodsNoValid.some(d => d.ValidationCode == -2)) {
                        NotificacionV2._Mostrar(_L("panelcicloescolar.notif_periods_date_intersect"), "ADVERTENCIA");
                    }
                    return false;
                }

                return true;
            },
        })
    }

    const form = new FormGenerator<MCicloEscolar>()
        ._Crear({
            OnLoad: (container) => {
                container.classed("form_cicloescolar_periodos", true);
            },
            LangModuleKeyInContext: "panelcicloescolar",
            LabelMaxWidth: 120,
            schema: schema,
            onValideForm: (dataForm) => {
                if (!usesMateriasModule) return true;
                const periodsASC = [...dataForm?.Periodos || []].sort((a, b) => new Date(a.Inicio).getTime() - new Date(b.Inicio).getTime());
                const periodFirst = periodsASC[0];
                const periodsDESC = [...dataForm?.Periodos || []].sort((b, a) => new Date(a.Fin).getTime() - new Date(b.Fin).getTime());
                const periodLast = periodsDESC[0];

                const periodFirstStartTime = new Date(periodFirst.Inicio).getTime()
                const periodLastEndTime = new Date(periodLast.Fin).getTime()

                const cicloStartTime = new Date(GetInputDateFixedTimeZoneByIdSchool(dataForm.FechaInicio, idSchool)._ToISOString()).getTime();
                const cicloEndTime = new Date(GetInputDateFixedTimeZoneByIdSchool(dataForm.FechaFin, idSchool)._ToISOString()).getTime();

                const isInRightLimit = periodFirstStartTime >= cicloStartTime;
                const isInLeftLimit = periodLastEndTime <= cicloEndTime;

                if (!isInRightLimit || !isInLeftLimit) {
                    NotificacionV2._Mostrar(_L("panelcicloescolar.notif_periods_outofrange"), "ADVERTENCIA");
                }
                return isInRightLimit && isInLeftLimit;
            },
        }, datoCicloInfoInForm)

    return form;
}

function UI_CreatePeriodsRow(rowSelection: TSelectionHTML<"div">, periods: ICicloEscolarPeriodo[], idSchool: number) {
    rowSelection.classed("periods_form_row", true);
    rowSelection.select(":scope > label").classed("periods_row_title", true);

    let periodsContainer = rowSelection.select(":scope > div.periods_manager_container");

    if (!periodsContainer.node()) {
        periodsContainer = rowSelection.append("div").classed("periods_manager_container", true)
        const periodsHeaderAction = periodsContainer.append("div")
            .classed("periods_manager_header_actions", true);

        let idAuxPeriod = 0;
        periodsHeaderAction.append("label")
            .text(_L("panelcicloescolar.action_addperiod")).classed("action_addperiod", true)
            .on("click", () => {
                UI_OpenModalAgregarPeriodo(idSchool, (period, mt) => {
                    period.Inicio = GetInputDateFixedTimeZoneByIdSchool(period.Inicio, idSchool)._ToISOString();
                    period.Fin = GetInputDateFixedTimeZoneByIdSchool(period.Fin, idSchool)._ToISOString();
                    let finLastInstant = new Date(period.Fin);
                    finLastInstant.setDate(finLastInstant.getDate() + 1);
                    finLastInstant.setMilliseconds(finLastInstant.getMilliseconds() - 1);
                    period.Fin = finLastInstant.toISOString();
                    const validationRes = ValidateSinglePeriod(period, periods);
                    if (validationRes < 0) return;
                    idAuxPeriod -= 1
                    periods.push({
                        Id: idAuxPeriod,
                        ...period
                    });
                    UI_RefreshPeriodsListSelectionView(periodsListContainer, periods, idSchool)
                    mt.Modal._Ocultar()
                });
            });
    }

    const periodsListContainer = periodsContainer.append("div").classed("periods_list_container", true);
    UI_RefreshPeriodsListSelectionView(periodsListContainer, periods, idSchool)
}

function UI_RefreshPeriodsListSelectionView(periodsListSelection: TSelectionHTML<"div">, data: ICicloEscolarPeriodo[], idSchool: number) {
    data.sort((a, b) => new Date(a.Fin).getTime() - new Date(b.Fin).getTime());
    data.sort((a, b) => new Date(a.Inicio).getTime() - new Date(b.Inicio).getTime());

    periodsListSelection.selectAll<HTMLDivElement, ICicloEscolarPeriodo>(":scope > .period_item")
        .data(data)
        .join(
            enter => {
                let itemPeriod = enter.append<HTMLDivElement>("div").classed("period_item", true)

                itemPeriod.append("label").classed("period_name", true);
                itemPeriod.append("label").classed("period_range", true);
                itemPeriod.append("div").html(CloseIcon).classed("close_icon", true)

                return UI_UpdatePeriodItemView(itemPeriod, periodsListSelection, data, idSchool);
            },
            update => UI_UpdatePeriodItemView(update, periodsListSelection, data, idSchool),
            exit => exit.remove()
        );
}

function UI_UpdatePeriodItemView(listPeriodItemView: TSelectionHTML<"div", ICicloEscolarPeriodo>, periodsListSelection: TSelectionHTML<"div">, data: ICicloEscolarPeriodo[], idSchool: number) {
    listPeriodItemView.each((d, i, items) => {
        let generalItem = d3.select<HTMLDivElement, ICicloEscolarPeriodo>(items[i]);

        generalItem.on("click", () => UI_OpenModalEditarPeriodo(d, idSchool, (period, mt) => {
            // Aquí se ajusta la fecha a la zona h. de la escuela
            period.Inicio = GetInputDateFixedTimeZoneByIdSchool(period.Inicio, idSchool)._ToISOString();
            period.Fin = GetInputDateFixedTimeZoneByIdSchool(period.Fin, idSchool)._ToISOString();
            let finLastInstant = new Date(period.Fin);
            finLastInstant.setDate(finLastInstant.getDate() + 1);
            finLastInstant.setMilliseconds(finLastInstant.getMilliseconds() - 1);
            period.Fin = finLastInstant.toISOString();

            const validationResult = ValidateSinglePeriod(period, data);
            if (validationResult < 0) return;

            d.Nombre = period.Nombre;
            d.Inicio = period.Inicio;
            d.Fin = period.Fin;
            UI_RefreshPeriodsListSelectionView(periodsListSelection, data, idSchool);
            mt.Modal._Ocultar();
        }))

        let periodNameLbl = generalItem.select(":scope > .period_name");
        let periodRangeLbl = generalItem.select(":scope > .period_range");
        let closeIcon = generalItem.select(":scope > .close_icon");

        closeIcon.on("click", () => {
            d3.event.stopPropagation();
            UI_OpenModalEliminarPeriodo(() => {
                const periodToDeleteIndex = data.findIndex(p => p.Id == d.Id);
                if (periodToDeleteIndex >= 0) {
                    data.splice(periodToDeleteIndex, 1)
                }

                UI_RefreshPeriodsListSelectionView(periodsListSelection, data, idSchool);
            });
        })

        periodNameLbl.text(d.Nombre);
        periodRangeLbl.text(`${UIUtilTime._DateFormatStandarFixTimeZoneByIdSchool(d.Inicio, idSchool)} - ${UIUtilTime._DateFormatStandarFixTimeZoneByIdSchool(d.Fin, idSchool)}`);
    })


    return listPeriodItemView;
}

function GetInputDateFixedTimeZoneByIdSchool(date: string, idSchool: number) {
    return new DateV2(UIUtilTime._GetLocalDateFromInputDateString(date))
        ._SetTimeZoneByIdSchool(idSchool, true)
}

function UI_OpenModalAgregarPeriodo(idSchool: number, onAccept: (period: ICicloEscolarPeriodo, mt: ModalThingsUtil.IModalThings) => void) {
    _ModalForm({
        Title: _L("panelcicloescolar.action_addperiod"),
        Action: Entidad.CAccionPermiso.Agregar,
        Width: 300,
        GetForm: () => GetPeriodoAgregarEditarForm(<ICicloEscolarPeriodo>{}, Entidad.CAccionPermiso.Agregar, idSchool),
        OnAccept: (form, mt) => {
            onAccept && onAccept(form._Data, mt);
            return null
        }
    })
}

function UI_OpenModalEditarPeriodo(period: ICicloEscolarPeriodo, idSchool: number, onAccept: (period: ICicloEscolarPeriodo, mt: ModalThingsUtil.IModalThings) => void) {
    _ModalForm({
        Title: _L("panelcicloescolar.action_editperiod"),
        Action: Entidad.CAccionPermiso.Editar,
        Width: 300,
        GetForm: () => GetPeriodoAgregarEditarForm(period, Entidad.CAccionPermiso.Editar, idSchool),
        OnAccept: (form, mt) => {
            onAccept && onAccept(form._Data, mt);
            return null;
        }
    })
}

async function UI_OpenModalEliminarPeriodo(onConfirm: () => void) {
    let confirmRes = await _ModalConfirmacionBasicoV2({
        Title: _L("panelcicloescolar.action_deleteperiod"),
        Content: _L("panelcicloescolar.confirm_deleteperiod"),
        Width: 300,
    })

    if (confirmRes) {
        onConfirm && onConfirm();
    }
}

function GetPeriodoAgregarEditarForm(period: ICicloEscolarPeriodo, action: CAccionPermiso.Agregar | CAccionPermiso.Editar, idSchool: number) {
    const periodForm: ICicloEscolarPeriodo = {
        ...period
    }

    periodForm.Inicio = periodForm?.Inicio ? UIUtilTime._FmtToInputDate(periodForm.Inicio, idSchool) : null;
    periodForm.Fin = periodForm?.Fin ? UIUtilTime._FmtToInputDate(periodForm.Fin, idSchool) : null;

    const form = new FormGenerator<ICicloEscolarPeriodo>()._Crear({
        LabelMaxWidth: 120,
        LangModuleKeyInContext: "panelcicloescolar",
        schema: [
            { model: "Nombre", labelText: "d_field_nombre", type: "input", inputAttr: { required: true } },
            {
                model: "Inicio", labelText: "d_field_fechainicio", type: "input", inputAttr: {
                    type: "date", required: true, onchange: (e) => {
                        const fechaInicioInput = e.target as HTMLInputElement;
                        if (!fechaInicioInput.value) return;
                        const fechaFinInput = form._ControlsData.get("Fin").selection.node() as HTMLInputElement;
                        fechaFinInput.min = CALC_MinDateValue(<ICicloEscolarPeriodo>{ Inicio: fechaInicioInput.value });
                    },
                }
            },
            { model: "Fin", labelText: "d_field_fechafin", type: "input", inputAttr: { type: "date", required: true, min: CALC_MinDateValue(<ICicloEscolarPeriodo>{ Inicio: periodForm.Inicio }) } },
        ],
    }, periodForm)

    return form;
}

function CALC_MinDateValue(period: ICicloEscolarPeriodo): string {
    if (!period.Inicio) return null;
    const dtFinMin = UIUtilTime._GetLocalDateFromInputDateString(period.Inicio);
    dtFinMin.setDate(dtFinMin.getDate() + 1);
    return UIUtilTime._FmtToInputDate(dtFinMin);
}

function ValidateSinglePeriod(periodToValidate: ICicloEscolarPeriodo, periods: ICicloEscolarPeriodo[], notify = true): number {
    const hasDuplicateName = periods.some(
        p => p.Id !== periodToValidate.Id && p.Nombre.trim() === periodToValidate.Nombre.trim()
    );

    if (hasDuplicateName) {
        notify && NotificacionV2._Mostrar(_L("panelcicloescolar.notif_period_name_rep"), "ADVERTENCIA");
        return -1;
    };

    // FORMULA STANDARD PARA INTERACCIÓN DE INTERVALOS 
    // (Inicio_A <= Fin_B) && (Fin_A >= Inicio_B)

    const startA = new Date(periodToValidate.Inicio).getTime();
    const endA = new Date(periodToValidate.Fin).getTime();

    const hasOverlap = periods.some(p => {
        if (p.Id === periodToValidate.Id) return false;

        const startB = new Date(p.Inicio).getTime();
        const endB = new Date(p.Fin).getTime();
        return (startA <= endB) && (endA >= startB);
    })

    if (hasOverlap) {
        notify && NotificacionV2._Mostrar(_L("panelcicloescolar.notif_period_date_intersect"), "ADVERTENCIA");
        return -2;
    };

    return 1;
}

export function ValidatePeriods(periods: ICicloEscolarPeriodo[]): ICicloEscolarPeriodoValidation[] {
    const periodsValidation = periods.map<ICicloEscolarPeriodoValidation>(d => ({ ...d, Valid: true, ValidationCode: 1 }))
    const names = new Map<string, number[]>();
    periodsValidation.forEach(period => {
        const normalizedName = period.Nombre.trim();
        if (!names.has(normalizedName)) {
            names.set(normalizedName, []);
        }
        names.get(normalizedName).push(period.Id);
    });

    names.forEach((ids) => {
        if (ids.length > 1) {
            periodsValidation.forEach(p => {
                if (ids.includes(p.Id)) {
                    p.Valid = false;
                    p.ValidationCode = -1;
                }
            })
        }
    });

    const periodsSorted = [...periodsValidation].sort((a, b) => new Date(a.Inicio).getTime() - new Date(b.Inicio).getTime());
    for (let i = 1; i < periodsSorted.length; i++) {
        const prev = periodsSorted[i - 1];
        const current = periodsSorted[i];

        const prevEnd = new Date(prev.Fin).getTime();
        const currentStart = new Date(current.Inicio).getTime();

        if (currentStart <= prevEnd) {
            const originalPrev = periodsValidation.find(p => p.Id === prev.Id);
            const originalCurrent = periodsValidation.find(p => p.Id === current.Id);

            if (originalPrev.Valid) {
                originalPrev.Valid = false;
                originalPrev.ValidationCode = -2;
            }

            if (originalCurrent.Valid) {
                originalCurrent.Valid = false;
                originalCurrent.ValidationCode = -2;
            }

        }
    }

    return periodsValidation;
}

export function GetEditionPeriodsObject(originalPeriodsBlock: ICicloEscolarPeriodo[], currentPeriodsBlock: ICicloEscolarPeriodo[]): { periodsAdd: ICicloEscolarPeriodo[], periodsEdit: ICicloEscolarPeriodo[], periodsDelete: ICicloEscolarPeriodo[] } {
    const periodsAdd: ICicloEscolarPeriodo[] = [];
    const periodsEdit: ICicloEscolarPeriodo[] = [];

    const originMap = new Map(originalPeriodsBlock.map(p => [p.Id, p]));
    for (const processedPeriod of currentPeriodsBlock) {
        if (processedPeriod.Id < 0) {
            periodsAdd.push(processedPeriod);
            continue;
        }

        const originPeriod = originMap.get(processedPeriod.Id);
        if (!originPeriod) {
            console.warn("-d", "Periodo no encontrado para ser evaluado", processedPeriod);
            continue;
        }

        if (
            originPeriod.Nombre !== processedPeriod.Nombre ||
            originPeriod.Inicio !== processedPeriod.Inicio ||
            originPeriod.Fin !== processedPeriod.Fin
        ) {
            periodsEdit.push(processedPeriod);
        }

        originMap.delete(processedPeriod.Id);
    }

    const periodsDelete = Array.from(originMap.values());

    return {
        periodsAdd,
        periodsEdit,
        periodsDelete,
    }
}

interface IPeriodRange {
    Inicio: Date;
    Fin: Date;
}
export function ValidatePeriodsIntersects(periodA: IPeriodRange, periodB: IPeriodRange) {
    return periodA.Inicio <= periodB.Fin && periodA.Fin >= periodB.Inicio;
}

export function GetStartAndEndRange(d: ICicloEscolarPeriodo[]) {
    const periodosSorted = [...d].sort((a, b) => new Date(a.Inicio).getTime() - new Date(b.Inicio).getTime());
    console.log(periodosSorted);

    const rangeStartDate = periodosSorted[0].Inicio
    const rangeEndDate = periodosSorted[periodosSorted.length - 1].Fin

    return { rangeStartDate, rangeEndDate }
}

export function GetPeriodsListFromCicloEscolar(cicloEscolar: ICicloEscolar | number, order: 'desc' | 'asc' = 'desc', onlyBeforeCurrent = true): ICicloEscolarPeriodo[] {
    let periods: ICicloEscolarPeriodo[] = [];

    if (typeof cicloEscolar == "number") {
        periods = DataModuloMain._GetDataValueFieldByName("CicloEscolar", cicloEscolar, "Periodos");
    } else {
        periods = cicloEscolar?.Periodos;
    }

    return (periods || []).sort((a, b) =>
        (new Date(a.Inicio).getTime() - new Date(b.Inicio).getTime()) *
        (order == 'desc' ? -1 : 1)
    ).filter(d =>
        !onlyBeforeCurrent || new Date(d.Inicio).getTime() <= new Date().getTime()
    );
}

export function GetCurrentNearestPeriod(periods: ICicloEscolarPeriodo[]): ICicloEscolarPeriodo {
    const dateNow = new Date();
    return periods.find(d => {
        let dtInicioPeriod = new Date(d.Inicio);
        let dtFinPeriod = new Date(d.Fin);
        return ValidatePeriodsIntersects({ Inicio: dateNow, Fin: dateNow }, { Inicio: dtInicioPeriod, Fin: dtFinPeriod })
    }) || periods[0];
}

export function PeriodsSort(periods: ICicloEscolarPeriodo[], order: 'desc' | 'asc' = 'desc') {
    return (periods || []).sort((a, b) =>
        (new Date(a.Inicio).getTime() - new Date(b.Inicio).getTime()) *
        (order == 'desc' ? -1 : 1)
    )
}